import { createContext, useContext, type ReactNode } from "react";
import type { ApiClient } from "./client.ts";

const ApiClientContext = createContext<ApiClient | undefined>(undefined);

export function ApiClientProvider({
  client,
  children,
}: {
  readonly client: ApiClient;
  readonly children: ReactNode;
}) {
  return <ApiClientContext value={client}>{children}</ApiClientContext>;
}

/** The typed Explorer API client; features build their query/mutation hooks on it. */
export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (!client) throw new Error("useApiClient must be used inside <ApiClientProvider>");
  return client;
}
